var e = {
    mon: "component_component_calendarPickerLabel_datesFilterMonday",
    tue: "component_component_calendarPickerLabel_datesFilterTuesday",
    wed: "component_component_calendarPickerLabel_datesFilterWednesday",
    thu: "component_component_calendarPickerLabel_datesFilterThursday",
    fri: "component_component_calendarPickerLabel_datesFilterFriday",
    sat: "component_component_calendarPickerLabel_datesFilterSaturday",
    sun: "component_component_calendarPickerLabel_datesFilterSunday"
  },
  n = {
    Jan: "component_component_calendarPickerLabel_datesFilterJanuary",
    Feb: "component_component_calendarPickerLabel_datesFilterFebruary",
    Mar: "component_component_calendarPickerLabel_datesFilterMarch",
    Apr: "component_component_calendarPickerLabel_datesFilterApril",
    May: "component_component_calendarPickerLabel_datesFilterMay",
    Jun: "component_component_calendarPickerLabel_datesFilterJune",
    Jul: "component_component_calendarPickerLabel_datesFilterJuly",
    Aug: "component_component_calendarPickerLabel_datesFilterAugust",
    Sep: "component_component_calendarPickerLabel_datesFilterSeptember",
    Oct: "component_component_calendarPickerLabel_datesFilterOctober",
    Nov: "component_component_calendarPickerLabel_datesFilterNovember",
    Dec: "component_component_calendarPickerLabel_datesFilterDecember"
  };
export { n as monthTranslationKeys, e as weekDayTranslationKeys };